<template>
  <svg aria-hidden="true" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" ...attributes>
    <ellipse cx="10.9777" cy="11" rx="10.9777" ry="11" fill="#e5e5e5"></ellipse>
    <path
      d="M8 8.05845C8.24196 7.37063 8.71954 6.79063 9.34815 6.42119C9.97676 6.05175 10.7158 5.9167 11.4345 6.03997C12.1531 6.16323 12.805 6.53686 13.2745 7.09467C13.7441 7.65248 14.0011 8.35847 14 9.0876C14 11.1459 10.9125 12.1751 10.9125 12.1751"
      stroke="#000"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path d="M10.9951 16.2917H11.0051" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
</template>
